module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAANCAYAAABy6+R8AAABLElEQVR4AZSSvUoDQRSF79zJRgWJb6GI+AgWFmJn0MCWgj6C1bpBcpMUqQQrIQ+gQrBJXsDOKg9ho4Uo/mCxIRnHOYsDswtBXPjgnsM5e3eZYXJPvz+ORAbVjgyPOzJqY/ZAw4dGzsWJuzK6en56fNd24UURXSprE8weaPjQLveGvNtkG2sbk9pZu15jUofMlGL2QMOHdrkVIttgsqTiODZY25S9QbNVP8fsgYYPnedcniH+S6HkfrrnvnlcBn744kJJR/bCsj4qA39uyU5VQmZ2Wyb3g1ZhU2VxSSL1vVsGftChQslkWW9GfA+M0lunsv8AkmTnY25pSssnumo2wep6dh0Gw5lJkRW5q8AU2c7S9OAVxL9nB9+T51ye3TW50fT51W0NJ3+BHPI/AAAA//+JJEaiAAAABklEQVQDAFhQxSPAjTDqAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/list3.png
// module id = pKkE
// module chunks = 167